<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Zone Commission for {{ plan.final_amount }}
          <v-progress-circular
            v-if="isMasterLoading"
            class="ml-5"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="zone_id"
                outlined
                :loading="isMasterLoading"
                v-model="form.zone_id"
                label="Zone  *"
                :items="zoneItems"
                prepend-inner-icon="mdi-dog"
                clearable
                :error-messages="errors.zone_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.walkie_percent"
                outlined
                label="Pet Walker Percentage"
                @input="CalculateCommission('WALKIE PERCENT CHANGE')"
                :hint="`Pet Walker Commission : ${this.form.walkie_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.franchisee_percent"
                outlined
                label="Franchisee Percentage"
                @input="CalculateCommission('FRANCHISEE PERCENT CHANGE')"
                :hint="`Franchisee Commission : ${this.form.franchisee_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.master_franchisee_percent"
                outlined
                label="Master Franchisee Percentage"
                @input="CalculateCommission('MASTER FRANCHISEE PERCENT CHANGE')"
                :hint="`Master Franchisee Commission : ${this.form.master_franchisee_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.company_percent"
                outlined
                label="Walkie Percentage"
                @input="CalculateCompanyAmount()"
                :hint="`Walkie Commission : ${this.form.company_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'plans'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Commission
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "PlanEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      plan: {
        no_of_dogs: "",
        no_of_walks: "",
        tier: "",
      },
      zoneItems: [],
      isLoading: false,
      isMasterLoading: false,
      isCalculating: false,
      is_basic_plan: true,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=zone_commissions`)
        .then(async (masters) => {
          masters = masters.data;
          //Position
          masters.zones.forEach((zone) => {
            this.zoneItems.push({
              id: zone.id,
              text: zone.description,
              value: zone.id,
            });
          });
          await this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.planZoneCommissionId;
      axios
        .get(`/plan_zone_commissions/${encryptedId}`)
        .then(async (response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
          await this.getPlanData();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async getPlanData() {
      let encryptedId = this.encryptIt(this.form.plan_id);
      axios
        .get(`/plans/${encryptedId}`)
        .then((response) => {
          this.plan = response.data.data;
          this.form.plan_id = this.plan.id;
          this.CalculateCommission();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
        
      this.isMasterLoading = false;
    },
    CalculateCommission(type = "") {
      const total = 100;

      let company = parseFloat(this.form.company_percent) || 0;
      let walkie = parseFloat(this.form.walkie_percent) || 0;
      let franchisee = parseFloat(this.form.franchisee_percent) || 0;
      let master = parseFloat(this.form.master_franchisee_percent) || 0;

      console.log("🔄 Recalculating commission — type:", type);

      // Adjust based on which one was changed
      if (type === "WALKIE PERCENT CHANGE") {
        company = total - (walkie + franchisee + master);
      } else if (type === "FRANCHISEE PERCENT CHANGE") {
        company = total - (walkie + franchisee + master);
      } else if (type === "MASTER FRANCHISEE PERCENT CHANGE") {
        company = total - (walkie + franchisee + master);
      } else {
        // Default case — recalc company to fill remainder
        company = total - (walkie + franchisee + master);
      }

      // ✅ Prevent negatives or overflows
      if (company < 0) company = 0;
      if (company > 100) company = 100;

      // Update back to form
      this.form.walkie_percent = parseFloat(walkie.toFixed(2));
      this.form.franchisee_percent = parseFloat(franchisee.toFixed(2));
      this.form.master_franchisee_percent = parseFloat(master.toFixed(2));
      this.form.company_percent = parseFloat(company.toFixed(2));

      // Then calculate amounts
      this.CalculateCommissionAmounts();
    },

    CalculateCommissionAmounts() {
      const totalAmount = parseFloat(this.plan.final_amount) || 0;
      const totalPercent =
        parseFloat(this.form.walkie_percent || 0) +
        parseFloat(this.form.franchisee_percent || 0) +
        parseFloat(this.form.master_franchisee_percent || 0) +
        parseFloat(this.form.company_percent || 0);

      // Normalize if total != 100
      const correctionFactor = totalPercent ? 100 / totalPercent : 1;

      const calc = (percent) =>
        Math.round((totalAmount * (percent * correctionFactor)) / 100);

      this.form.walkie_commission_amount = calc(this.form.walkie_percent);
      this.form.franchisee_commission_amount = calc(
        this.form.franchisee_percent
      );
      this.form.master_franchisee_commission_amount = calc(
        this.form.master_franchisee_percent
      );
      this.form.company_commission_amount = calc(this.form.company_percent);

      // 🔢 Optional: Ensure sum = totalAmount exactly
      const sum =
        this.form.walkie_commission_amount +
        this.form.franchisee_commission_amount +
        this.form.master_franchisee_commission_amount +
        this.form.company_commission_amount;

      // Small rounding adjustment
      if (sum !== totalAmount) {
        const diff = totalAmount - sum;
        this.form.company_commission_amount += diff;
      }

      console.log("✅ Commission recalculated:", {
        walkie: this.form.walkie_commission_amount,
        franchisee: this.form.franchisee_commission_amount,
        master: this.form.master_franchisee_commission_amount,
        company: this.form.company_commission_amount,
        total: totalAmount,
      });
    },

    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(
            `/plan_zone_commissions/${this.$route.params.planZoneCommissionId}`,
            this.form
          )
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.go(-1);
          })
          .catch((error) => {
            if (error.response?.status === 422) {
              // Validation error
              const errors = error.response.data;
              console.log(errors);

              this.isLoading = false;
            } else {
              console.error(error);
              this.isUnAuthorised();
            }
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
